import { Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'pixl-free-filter-input',
  imports: [
    MatIconModule,
    MatInputModule
  ],
  templateUrl: './free-filter-input.component.html',
  styleUrl: './free-filter-input.component.scss'
})
export class FreeFilterInputComponent {
  public hint = input('');
  public minLength = input(3);
  public matIcon = input();
  public label = input('');
  public onKeyUpChange = output<string>();
  public showHint = signal(false);

  public onKeyUpEvent(ev: Event) {
    const val = (ev.target as HTMLInputElement).value;
    if (val.length === 0) {
      this.showHint.set(false);
      this.onKeyUpChange.emit(val);
      return;
    }

    if (this.minLength() > -1 && val.length > 0 && val.length < this.minLength()) {
      this.showHint.set(true);
      return;
    }

    this.showHint.set(false);
    this.onKeyUpChange.emit(val);
  }
}
